import BlacklistEntity from "./BlacklistEntity";
export default BlacklistEntity;
